import type { ExtensionParams } from '@atlaskit/editor-common/extensions';
import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { RedactionExtensionParams } from '../redaction-constants.ts';

export const TourableRedactionExtensionLoader: LoadableType<{
	contentId?: string | null;
	extensionNode: ExtensionParams<RedactionExtensionParams>;
	isCommentContext?: boolean;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TourableRedactionExtension" */ './TourableRedactionExtension.tsx'
			)
		).TourableRedactionExtension,
});
